<template>
  <div>
    <v-expansion-panels v-model="panel">
      <draggable
        style="width: 100%"
        :list="GetForumCategories"
        animation="300"
        @end="handleSortCategory"
      >
        <v-expansion-panel
          v-for="item in GetForumCategories"
          :key="item?.Id"
          class="p-0 mt-0"
        >
          <v-expansion-panel-header class="p-0" :expand-icon="''">
            <span class="px-4">
              <costumicon />
              <span class="pl-2"> {{ item.Name }}</span>
            </span>
          </v-expansion-panel-header>
          <draggable
            animation="300"
            :list="item.Subcategories"
            @end="handleSortSubCategory"
          >
            <v-expansion-panel-content
              v-for="list in item.Subcategories"
              :key="list?.Id"
              class="p-0"
              :class="item?.Id"
            >
              <div class="px-4 py-3">
                <v-row>
                  <v-col cols="12" md="10" class="d-flex align-center">
                    <Costumicon2 />

                    <span class="do not remove this span opacity-0"
                      >{{ item?.Id }} _</span
                    >
                    <span class="pl-2">
                      {{ list.SubCategoryName }}
                    </span>
                    <img
                      v-if="list.CategoryImage"
                      :src="list.CategoryImage"
                      alt="icon"
                      style="height: 28px; width: 28px; object-fit: contain; border-radius: 4px; background: #f0f0f0; padding: 2px; margin-left: 8px;"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <div class="d-flex justify-end">
                      <v-icon @click="editItem(item, list)">mdi-pencil</v-icon>
                      <v-icon
                        class="ml-3 mr-2"
                        @click="openConfirmDialog(list)"
                      >
                        mdi-delete-outline</v-icon
                      >
                    </div>
                  </v-col>
                </v-row>
              </div>
              <v-divider class="m-0"></v-divider>
            </v-expansion-panel-content>
          </draggable>
        </v-expansion-panel>
      </draggable>
    </v-expansion-panels>

    <!-----------------edit dialog-------------------------------->
    <v-dialog v-model="editdialog" width="450" persistent>
      <v-card flat>
        <div class="px-8 pt-5 d-flex justify-space-between">
          <h5 class="text_style">Edit Subcategorys</h5>
          <v-icon @click="closeSubCategoryDialog()">mdi-close</v-icon>
        </div>
        <span></span>
        <v-card color="#F6F8FC" flat class="py-5 px-8">
          <v-autocomplete
          attach
            :error-messages="
              $v.Subcategory.category.$error ? 'Category is required' : null
            "
            :items="GetForumCategories"
            item-text="Name"
            item-value="Id"
            label="Select Category"
            v-model="Subcategory.category"
          ></v-autocomplete>
          <v-text-field
            :error-messages="
              $v.Subcategory.name.$error ? 'Name is required' : null
            "
            v-model="Subcategory.name"
            label="Name Subcategory"
          ></v-text-field>
          <v-autocomplete
            :error-messages="
              $v.Subcategory.permissions.$error
                ? 'User Level Permissions are required'
                : null
            "
            :items="getMembership"
            attach
            item-text="Name"
            item-value="Id"
            label=" User Level Permissions"
            v-model="Subcategory.permissions"
            multiple
          ></v-autocomplete>
          <v-autocomplete
            v-model="Subcategory.course"
            :items="GetCoursesIDsAndTitle"
            attach
            item-text="Title"
            item-value="Id"
            label="Course Permissions"
            multiple
          ></v-autocomplete>
          <v-autocomplete
            :items="credentailsitems"
            v-model="Subcategory.instructor"
            attach
            label=" Instructor Credential Permissions"
            multiple
          ></v-autocomplete>
          <v-card
            class="absolute__deleteBtn"
            v-for="(user, index) in AssignedUsers"
            :key="index"
            color="transparent"
            flat
          >
            <v-autocomplete
              :clearable="index === 0"
              :items="GetAllInstructorsIDsAndNames"
              item-text="Name"
              item-value="Id"
              label="Assign Individual User "
              v-model="AssignedUsers[index]"
              />
              <v-icon
              v-if="index !== 0"
              color="red"
              @click="removeAnotherField(index)"
              >
              mdi-delete</v-icon
            >
          </v-card>
          <v-btn
            @click="addAnotherField()"
            color="primary"
            text
            style="text-transform: none"
            >+Add Another
          </v-btn>
          <h5 class="">File</h5>
          <div class="d-flex align-center">
            <v-btn
              class="text_style mb-4 px-8"
              color="primary"
              outlined
              @click="onButtonClickThumbnail"
              >Upload Default</v-btn
            >
            <input
              ref="uploader1"
              class="d-none"
              type="file"
              @change="onFileChangedThumbnail"
            />
            <div class="d-flex align-center ml-4" style="height: 100%">
              <v-chip
                color="primary"
                class="mt-n4"
                @click:close="closechip()"
                v-show="chip2"
                close
                outlined
                pill
              >
                {{ Subcategory.UploadedThumbnail }}
              </v-chip>
              <p style="color: #8080808f" v-if="!chip2">(400 x 200 px)</p>
            </div>
          </div>
          <img
            v-if="existingIconUrl"
            :src="existingIconUrl"
            alt="Current icon"
            style="display: block; height: 48px; width: 48px; object-fit: contain; border-radius: 8px; margin-bottom: 6px; background: #f0f0f0; padding: 4px;"
          />
          <h5 class="mt-2">Icon</h5>
          <div class="d-flex align-center">
            <v-btn
              class="text_style mb-4 px-8"
              color="primary"
              outlined
              @click="onButtonClickIcon"
              >Upload Icon</v-btn
            >
            <input
              ref="uploaderIcon"
              class="d-none"
              type="file"
              accept="image/*"
              @change="onFileChangedIcon"
            />
            <div class="d-flex align-center ml-4" style="height: 100%">
              <v-chip
                color="primary"
                class="mt-n4"
                @click:close="closechipIcon()"
                v-show="chip3"
                close
                outlined
                pill
              >
                {{ Subcategory.UploadedIcon }}
              </v-chip>
              <p style="color: #8080808f" v-if="!chip3 && !existingIconUrl">(icon image)</p>
            </div>
          </div>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="pa-3">
            <v-btn
              class="px-14 py-6 mb-2 text_trans"
              color="grey lighten-1"
              text
              @click="closeSubCategoryDialog()"
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="btnloader"
              color="primary"
              class="px-14 py-6 mb-2 text_trans"
              @click="EditSubcategory()"
            >
              <v-progress-circular
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-if="btnloader"
              ></v-progress-circular>
              <span v-else>Save</span>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-----------------Delete dialog-------------------------------->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogDelete = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="btnloader"
            @click="deleteSubcategory()"
          >
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import costumicon from "../Video/costumicon.vue";
import Costumicon2 from "../Video/costumicon2.vue";
import draggable from "vuedraggable";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "OrganizeComponent",
  components: { costumicon, Costumicon2, draggable },

  data() {
    return {
      chip2: false,
      chip3: false,
      selectedIconFile: null,
      existingIconUrl: null,
      panel: null,
      deleteSubcategoryId: null,
      model: [],
      Subcategory: {
        category: "",
        name: "",
        permissions: [],
        course: [],
        instructor: [],
        Id: null,
        UploadedThumbnail: "",
        UploadedIcon: "",
      },
      defaultImage: null,
      btnloader: false,
      dialog: false,
      dialogDelete: false,
      editdialog: false,
      expanded: [],
      credentailsitems: ["BAT", "CBI", "SrCBI", "CBI-A", "BrI", "MSI", "FFI"],
      AssignedUsers: [""],
      InstructorsArray:[]
    };
  },
  validations: {
    Subcategory: {
      category: { required },
      name: { required },
      permissions: { required: function () {
          return this.requireUserPermissions;
        }, },
    },
  },
  mounted() {
  },
  computed: {
    ...mapGetters([
      "GetCoursesIDsAndTitle",
      "getMembership",
      "GetForumCategories",
      "GetLoggedInUser",
      "GetAllInstructorsIDsAndNames"
    ]),
    requireUserPermissions() {
      if(this.Subcategory?.permissions?.length > 0){
        return true;
      } else {
        // Check if any user is assigned; if not, require user-level permissions
        return this.AssignedUsers.every(user => user);
      }
    },
  },
  methods: {
    isDateGreaterThanCurrent(dateStr) {
      var currentDate = new Date();
      var givenDate = new Date(dateStr);

      // Extract year, month, and day from the current date
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth() + 1; // Months are 0 indexed
      var currentDay = currentDate.getDate();

      // Extract year, month, and day from the given date
      var givenYear = givenDate.getFullYear();
      var givenMonth = givenDate.getMonth() + 1; // Months are 0 indexed
      var givenDay = givenDate.getDate();

      // Compare years
      if (givenYear > currentYear) {
        return true;
      } else if (givenYear < currentYear) {
        return false;
      }

      // If years are the same, compare months
      if (givenMonth > currentMonth) {
        return true;
      } else if (givenMonth < currentMonth) {
        return false;
      }

      // If months are the same, compare days
      if (givenDay > currentDay) {
        return true;
      } else {
        return false;
      }
    },
    closechip() {
      this.chip2 = false;
    },
    closechipIcon() {
      this.chip3 = false;
      this.selectedIconFile = null;
      this.Subcategory.UploadedIcon = '';
    },
    onButtonClickThumbnail() {
      this.$refs.uploader1.click();
    },
    onFileChangedThumbnail(e) {
      this.chip2 = true;
      this.Subcategory.Thumbnail = e.target.files[0];
      this.Subcategory.UploadedThumbnail =
        this.Subcategory.Thumbnail.name.substring(0, 16);
      this.$refs.uploader1.value = null;
    },
    onButtonClickIcon() {
      this.$refs.uploaderIcon.click();
    },
    onFileChangedIcon(e) {
      this.chip3 = true;
      this.existingIconUrl = null;
      this.selectedIconFile = e.target.files[0];
      this.Subcategory.UploadedIcon =
        this.selectedIconFile.name.substring(0, 16);
      this.$refs.uploaderIcon.value = null;
    },
    handleSortCategory(event) {
      const newOrder = event.newIndex; // Get the new index of the dragged item
      const itemId = event.item._underlying_vm_.Id; // Get the ID of the dragged item
      const payload = {
        sortNum: newOrder,
        Id: itemId,
      };
      this.$store.dispatch("SortForumCategory", payload).then(() => {
        this.$store.dispatch("GetForumCategories");
      });
    },
    handleSortSubCategory(event) {
      const newOrder = event.newIndex; // Get the new index of the dragged item
      const subCategoryId = event.item._underlying_vm_.Id; // Get the ID of the dragged subcatogery
      const itemId = Number(event.item.innerText.split("_")[0]); // Get the ID of the dragged item
      const payload = {
        sortNum: newOrder,
        Id: subCategoryId,
        categoryId: itemId,
      };
      this.$store.dispatch("SortForumSubCategory", payload).then(() => {
        this.$store.dispatch("GetForumCategories");
      });
    },
    EditSubcategory() {
      this.$v.Subcategory.$touch();
      if (this.$v.Subcategory.$invalid) {
        return;
      } else {
        const Courses = this.Subcategory.course;
        const PermissionId = this.Subcategory.permissions;
        const InstructorCredentials = this.Subcategory.instructor;
        const AssignedUsers = this.AssignedUsers.filter(
          (item) => item !== "" && item !== null
        ).join();
        const payload = {
          Id: this.Subcategory?.Id,
          CategoryId: this.Subcategory.category,
          SubCategoryName: this.Subcategory.name,
          Courses: Courses ? Courses.join() : "",
          PermissionId: PermissionId ? PermissionId.join() : "",
          InstructorCredentials: InstructorCredentials
            ? InstructorCredentials.join()
            : "",
          AssignedUsers: AssignedUsers,
          SubmittedBy: this.GetLoggedInUser?.Id,
          File: this.Subcategory.Thumbnail,
        };
        const formData = new FormData();
        formData.append("Id", payload.Id);
        formData.append("CategoryId", payload.CategoryId);
        formData.append("SubCategoryName", payload.SubCategoryName);
        formData.append("Courses", payload.Courses);
        formData.append("SubmittedBy", payload.SubmittedBy);
        formData.append("PermissionId", payload.PermissionId);
        formData.append("InstructorCredentials", payload.InstructorCredentials);
        formData.append("AssignedUsers", payload.AssignedUsers);
        if (payload.File && payload.File !== undefined) {
          formData.append("File", payload.File);
        }
        if (this.selectedIconFile) {
          formData.append("CategoryImage", this.selectedIconFile);
        }
        this.btnloader = true;
        this.$store
          .dispatch("EditSubCategory", formData)
          .then((res) => {
            if (res.Status) {
              this.$emit(
                "GetForumCategories",
                "Edited Subcategory Successfully"
              );
              this.closeSubCategoryDialog();
              } else {
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 3000,
              });
            }
            this.btnloader = false;
          })
          .catch(() => {
            this.btnloader = false;
          });
      }
    },
    deleteSubcategory() {
      this.btnloader = true;
      this.$store
        .dispatch("RemveSubCategory", this.deleteSubcategoryId)
        .then((res) => {
          this.btnloader= false;
          this.dialogDelete = false;
          if (res.data.Status) {
            this.$emit(
              "GetForumCategories",
              "SubCategory deleted successfully"
              // "Cannot delete subCategory that is in use"
            );
          } else {
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: res.data.Message,
              showConfirmButton: false,
              timer: 2500,
            });
          }
        });
    },
    closeSubCategoryDialog() {
      this.editdialog = false;
      this.chip2 = false;
      this.chip3 = false;
      this.selectedIconFile = null;
      this.existingIconUrl = null;
      this.Subcategory = {
        category: "",
        name: "",
        permissions: [],
        course: [],
        instructor: [],
        UploadedThumbnail: "",
        UploadedIcon: "",
      };
      this.$v.Subcategory.$reset();
    },
    clickRow(item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex((i) => i === item);
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(item);
      }
    },

    editItem(item, list) {
      if (list.FileUrl) {
        this.chip2 = true;
      }
      if (list.CategoryImage) {
        this.chip3 = false;
        this.selectedIconFile = null;
        this.existingIconUrl = list.CategoryImage;
        this.Subcategory.UploadedIcon = '';
      } else {
        this.chip3 = false;
        this.selectedIconFile = null;
        this.existingIconUrl = null;
        this.Subcategory.UploadedIcon = '';
      }
      const permissionsArray = list.Permissions 
        ? list.Permissions.map(permission => permission.PermissionId)
        : [];
      this.Subcategory.permissions = permissionsArray;
      if (list.FileUrl) {
        this.defaultImage = list.FileUrl.split("_").slice(-1).join();
        this.Subcategory.UploadedThumbnail = this.defaultImage.substring(0, 16);
        console.log("thumbnail", this.Subcategory.UploadedThumbnail);
      }
      const coursesArray = list.Courses 
        ? list.Courses.map(course => course.CourseId)
        : [];
      this.Subcategory.course = coursesArray;
      
      this.Subcategory.category = item?.Id;
      this.Subcategory.name = list.SubCategoryName;
      this.Subcategory.Id = list?.Id;
      if (list.AssignedUsers && list.AssignedUsers.length > 0) {
        this.AssignedUsers = Array.isArray(list.AssignedUsers)
          ? list.AssignedUsers
          : list.AssignedUsers.split(",").map(Number);
      } else {
        this.AssignedUsers = [""];
      }
      if (list.InstructorCredentials) {
        this.Subcategory.instructor = Array.isArray(list.InstructorCredentials)
          ? list.InstructorCredentials
          : list.InstructorCredentials.split(",");
      }
      this.editdialog = true;
    },
    openConfirmDialog(list) {
      this.deleteSubcategoryId = list?.Id;
      this.dialogDelete = true;
    },

    close() {
      this.$emit("close");
    },
    addAnotherField() {
      this.AssignedUsers.push("");
    },
    removeAnotherField(index) {
      this.AssignedUsers.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
.absolute__deleteBtn {
  position: relative;
  .mdi-delete {
    position: absolute !important;
    right: 0px;
    top: 16px;
  }
}
.v-expansion-panel-content__wrap {
  padding: 0 !important;
  flex: 1 1 auto;
  max-width: 100%;
}
.v-expansion-panel-header {
  min-height: 50px;
  background: #ecf1f2;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 50px;
  background: #ecf1f2;
}
.v-expansion-panel::before {
  box-shadow: none !important;
}
/* table.v-table tbody td {
    height: 40px;
    border: none;
}
.theme--light.v-table tbody tr:not(:last-child) {
    border-bottom: none;
}
table { border-collapse:collapse }
table td, table th {
  height: 40px; 
} */
</style>
